import { useState } from "react";
import { toast } from "sonner";
import type { HelpHubDTO, HelpHubGuideDTO } from "@/types/help-hub/help-hub";

/** Keep the existing lazy PDF export out of the page component and initial bundle. */
export const useHelpGuideDownload = (hub: HelpHubDTO | null | undefined, guide: HelpHubGuideDTO | null | undefined) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const download = async () => {
    if (!hub || !guide?.genieDocument || isDownloading) return;
    const document = guide.genieDocument;
    setIsDownloading(true);
    try {
      const { downloadGenieDocumentPdf } = await import("@/services/genie-documents/genieDocumentPdf");
      await downloadGenieDocumentPdf({
        title: document.title, subtitle: document.subtitle ?? undefined,
        template: document.template, sections: document.sections,
      }, {
        name: hub.branding.brandName || hub.name, logoUrl: hub.branding.logoUrl,
        primaryColor: hub.branding.primaryColor, secondaryColor: hub.branding.secondaryColor,
      });
    } catch {
      toast.error("Couldn't prepare the PDF — please try again.");
    } finally {
      setIsDownloading(false);
    }
  };
  return { isDownloading, download };
};
